export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/strike-4c9c30591fd5df34623e6b27a2e2a311.png";